/* eslint-disable import/prefer-default-export */
import { easyPost } from './utils';

// 查询用户可用的芝麻go任务
export const getZhiMaGoTask = easyPost('common.zhima.detail');

// 退出芝麻go任务
export const signOutZhiMaExit = easyPost('platform.zmgo.unSign');
